import { Page } from '@wix/design-system';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useEntityPageChild } from '../../hooks';
import { EntityPageProps } from './EntityPage';
import { FieldValues } from 'react-hook-form';

export interface EntityPagePlainProps<T, V extends FieldValues = FieldValues>
  extends EntityPageProps<T, V> {}

function _EntityPagePlain<T, V extends FieldValues = FieldValues>({
  state,
  children,
  ...rest
}: EntityPagePlainProps<T, V>) {
  const childrenArr = useEntityPageChild(children);

  return <Page {...rest}>{childrenArr}</Page>;
}

export const EntityPagePlain = observer(_EntityPagePlain);
